<template>
  <v-card class="mt-0 flex d-flex flex-column" outlined :loading="loading">
    <v-card-title class="justify-center"> Downgraded Listings </v-card-title>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="subscriptions"
        :items-per-page="size"
        :server-items-length="serverItemsLength"
        :options.sync="paginationOptions"
        :footer-props="{
          'items-per-page-options': [10, 20, 50, 100]
        }"
        @update:options="updatePaginationOptions($event)"
        class="elevation-0"
        dense
      >
        <template v-slot:item.companyName="{ item }">
          <router-link
            :to="{
              name: 'CompanyShow',
              params: { companyId: item.companyId }
            }"
          >
            {{ item.companyId }} -
            {{ item.companyName }}
          </router-link>
        </template>

        <template v-slot:item.updatedAt="{ item }">
          {{ item.updatedAt | date }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { listSubscriptions } from "../../api/subscription";

export default {
  name: "DowngradedFacilities",

  data() {
    return {
      loading: false,
      subscriptions: [],
      page: 0,
      size: 10,
      serverItemsLength: 0,
      paginationOptions: {
        itemsPerPage: 10,
        page: 1
      },
      headers: [
        {
          text: "Listing ID",
          sortable: false,
          value: "facilityId"
        },
        {
          text: "Listing Name",
          sortable: false,
          value: "facilityName"
        },
        {
          text: "Provider",
          sortable: false,
          value: "companyName"
        },
        {
          text: "Downgrade Date",
          sortable: false,
          value: "updatedAt"
        }
      ]
    };
  },

  mounted() {
    this.searchSubscriptions();
  },

  methods: {
    async searchSubscriptions() {
      this.offset = 0;
      this.paginationOptions.page = 1;

      await this.getSubscriptions();
    },

    updatePaginationOptions(paginationOptions) {
      this.page = paginationOptions.page - 1;
      this.size = paginationOptions.itemsPerPage;

      this.getSubscriptions();
    },

    async getSubscriptions() {
      try {
        this.loading = true;
        const result = await listSubscriptions(
          this.page,
          this.size,
          false,
          null
        );
        this.serverItemsLength = result.total;
        this.subscriptions = result.items;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.error(e);
      }
    }
  }
};
</script>
